import { Box, Typography } from '@mui/material';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';

const WarningToMailSampleBack = () => {
  const { theme } = useThemeContext();
  return (
    <Box
      sx={{
        display: 'flex',
        maxWidth: '600px',
        margin: '0 auto',
        alignItems: 'flex-start',
      }}
    >
      <img
        style={{
          marginRight: '12px',
          marginTop: '9px',
        }}
        src={theme.custom.components.warningToMailSampleBack.exclamationIcon.src}
        alt="exclamation"
      />
      <Typography
        sx={{
          fontSize: '0.875rem',
          mt: 1,
          mb: 2,
        }}
        color={theme.custom.components.warningToMailSampleBack.title.color}
        align="left"
      >
        Please allow 10-30 minutes to collect your sample and make sure to mail it back on the same day.
      </Typography>
    </Box>
  );
};

export default WarningToMailSampleBack;
